import { z } from 'zod';

/**
 * Login form validation schema
 */
export const loginSchema = z.object({
    email: z.string().email('Please enter a valid email address'),
    password: z.string().min(1, 'Password is required'),
});

/**
 * Register form validation schema
 */
export const registerSchema = z
    .object({
        email: z.string().email('Please enter a valid email address'),
        password: z
            .string()
            .min(8, 'Password must be at least 8 characters long')
            .regex(/^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/, 'Password must contain at least one uppercase letter, one digit, and one special character'),
        password_confirmation: z.string().min(1, 'Please confirm your password'),
    })
    .refine((data) => data.password === data.password_confirmation, {
        message: 'Password confirmation does not match',
        path: ['password_confirmation'],
    });

/**
 * Forgot password form validation schema
 */
export const forgotPasswordSchema = z.object({
    email: z.string().email('Please enter a valid email address'),
});

/**
 * Reset password form validation schema
 */
export const resetPasswordSchema = z
    .object({
        new_password1: z
            .string()
            .min(8, 'Password must be at least 8 characters long')
            .regex(/^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/, 'Password must contain at least one uppercase letter, one digit, and one special character'),
        new_password2: z.string().min(1, 'Please confirm your password'),
    })
    .refine((data) => data.new_password1 === data.new_password2, {
        message: 'Password confirmation does not match',
        path: ['new_password2'],
    });

// Type exports
export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
